module.exports = __webpack_public_path__ + "img/display.1d0e14.svg";